/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button } from "@nordcloud/gnui";
import { StyledLink } from "~/components";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { CustomActionsTable } from "~/views/customActions/components/CustomActionsTable";

const breadcrumbsLabels = [
  { label: "Dashboard", uri: "/" },
  { label: "Custom Actions", uri: ROUTES.customActions.index },
];

export function CustomActionsPage() {
  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Custom Actions"
            customBreadcrumbs={breadcrumbsLabels}
          >
            <StyledLink to={ROUTES.customActions.create}>
              <Button icon="plus">Create Action</Button>
            </StyledLink>
          </BreadcrumbsBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <CustomActionsTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
